import React from 'react'

function TeamArea() {
  return (
	 <section className="team-area team-bg">
            <div className="container custom-container">
              <div className="row">
                <div className="col-12">
                  <div className="third-section-title text-center mb-60">
                    <h2>MEET <span>OUR</span> TEAM</h2>
                  </div>
                </div>
              </div>
              <div className="row justify-content-center">
                <div className="col-xl-3 col-lg-4 col-md-6 col-sm-8">
                  <div className="third-team-item text-center mb-30">
                    <div className="third-team-img">
                      <img src="assets/img/team/team_img01.png" alt="" />
                    </div>
                    <div className="third-team-content">
                      <div className="main-bg" />
                      <div className="hover-bg" />
                      <h5><a href="/#">Jannie Visscher</a></h5>
                      <span>weapon master</span>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-sm-8">
                  <div className="third-team-item text-center mb-30">
                    <div className="third-team-img">
                      <img src="assets/img/team/team_img02.png" alt="" />
                    </div>
                    <div className="third-team-content">
                      <div className="main-bg" />
                      <div className="hover-bg" />
                      <h5><a href="/#">warren buffett</a></h5>
                      <span>team leader</span>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-sm-8">
                  <div className="third-team-item text-center mb-30">
                    <div className="third-team-img">
                      <img src="assets/img/team/team_img03.png" alt="" />
                    </div>
                    <div className="third-team-content">
                      <div className="main-bg" />
                      <div className="hover-bg" />
                      <h5><a href="/#">anne hathaway</a></h5>
                      <span>weapon master</span>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6 col-sm-8">
                  <div className="third-team-item text-center mb-30">
                    <div className="third-team-img">
                      <img src="assets/img/team/team_img04.png" alt="" />
                    </div>
                    <div className="third-team-content">
                      <div className="main-bg" />
                      <div className="hover-bg" />
                      <h5><a href="/#">poll worker</a></h5>
                      <span>team member</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
  )
}

export default TeamArea